/**
 * Stepper Mensagem → Destino do sheet de follow-up.
 */
import React from 'react';
import type { FollowUpSheetTab } from '../hooks/useFollowUpFormSheet';

const STEPS: Array<{ id: FollowUpSheetTab; label: string }> = [
    { id: 'mensagem', label: 'Mensagem' },
    { id: 'destino', label: 'Destino' },
];

interface FollowUpSheetTabsProps {
    value: FollowUpSheetTab;
    onChange: (tab: FollowUpSheetTab) => void;
}

export default function FollowUpSheetTabs({ value, onChange }: FollowUpSheetTabsProps) {
    const current = Math.max(1, STEPS.findIndex((step) => step.id === value) + 1);
    const total = STEPS.length;
    const label = STEPS[current - 1]?.label ?? STEPS[0].label;

    return (
        <nav aria-label="Etapas do follow-up">
            <ol className="flex gap-s1">
                {STEPS.map((step, index) => {
                    const stepNumber = index + 1;
                    const reached = stepNumber <= current;
                    return (
                        <li key={step.id} className="min-w-0 flex-1">
                            <button
                                type="button"
                                onClick={() => onChange(step.id)}
                                aria-current={step.id === value ? 'step' : undefined}
                                aria-label={`Passo ${stepNumber} de ${total} — ${step.label}`}
                                className={`h-1.5 w-full touch-manipulation rounded-full transition-colors ${
                                    reached ? 'bg-primary' : 'bg-surface-subtle'
                                }`}
                            />
                        </li>
                    );
                })}
            </ol>
            <p className="mt-s2 text-sm text-muted" aria-live="polite">
                Passo {current} de {total} — {label}
            </p>
        </nav>
    );
}
